// Breadcrumb identifiers
const brandBreadcrumbIdentifier = {
    route: 'settings.brands.edit',
    parameterLabel: 'brand',
    parameters: ['brand']
}
const taxRuleBreadcrumbIdentifier = {
    route: 'settings.tax-rules.edit',
    parameterLabel: 'tax_rule',
    parameters: ['tax_rule']
}
const taxExemptionBreadcrumbIdentifier = {
    route: 'settings.tax-exemption.edit',
    parameterLabel: 'tax_exemption',
    parameters: ['tax_exemption']
}
const accountingProductsBreadcrumbIdentifier = {
    route: 'settings.accounting-products.edit',
    parameterLabel: 'accounting_product',
    parameters: ['accounting_product']
}
const accountBreadcrumbIdentifier = {
    route: 'products.accounts.show',
    parameterLabel: 'account',
    parameters: ['account']
}
const accountGroupBreadcrumbIdentifier = {
    route: 'products.account-groups.edit',
    parameterLabel: 'account_group',
    parameters: ['account_group']
}
const dnsTemplateBreadcrumbIdentifier = {
    route: 'products.dns-templates.show',
    parameterLabel: 'dns_template',
    parameters: ['dns_template']
}
const bankAccountBreadcrumbIdentifier = {
    route: 'settings.bank-accounts.edit',
    parameterLabel: 'bankAccount',
    parameters: ['bankAccount']
}
const creditNoteTypeBreadcrumbIdentifier = {
    route: 'settings.credit-note-types.edit',
    parameterLabel: 'credit_note_type',
    parameters: ['credit_note_type']
}
const taxRulesCreditNotesBreadcrumbIdentifier = {
    route: 'settings.tax-rules-credit-notes.edit',
    parameterLabel: 'tax_rules_credit_note',
    parameters: ['tax_rules_credit_note']
}
const customerSegmentsBreadcrumbIdentifier = {
    route: 'settings.customer-segments.edit',
    parameterLabel: 'customer_segment',
    parameters: ['customer_segment']
}
const orderManualCheckGroupIdentifier = {
    route: 'settings.order-manual-check-group-settings.edit',
    parameterLabel: 'order_manual_check_group_setting',
    parameters: ['order_manual_check_group_setting']
}
const orderManualCheckIdentifier = {
    route: 'settings.order-manual-check-settings.edit',
    parameterLabel: 'order_manual_check_setting',
    parameters: ['order_manual_check_setting']
}
const permissionIdentifier = {
    route: 'settings.permissions.edit',
    parameterLabel: 'permission',
    parameters: ['permission']
}
const paymentTermBreadcrumbIdentifier = {
    route: 'settings.payment-terms.edit',
    parameterLabel: 'paymentTerm',
    parameters: ['paymentTerm']
}
const domainConfigurationIdentifier = {
    route: 'settings.domain-configuration.edit',
    parameterLabel: 'domain_configuration',
    parameters: ['domain_configuration']
}
const idnCharacterSetIdentifier = {
    route: 'settings.idn-character-sets.edit',
    parameterLabel: 'idn_character_set',
    parameters: ['idn_character_set']
}

const invoiceDeliveryTypeIdentifier = {
    route: 'settings.invoice-delivery-types.edit',
    parameterLabel: 'invoice_delivery_type',
    parameters: ['invoice_delivery_type']
}
const marketRegionBreadcrumbIdentifier = {
    route: 'settings.market-regions.edit',
    parameterLabel: 'market_region',
    parameters: ['market_region']
}
const dunningFeesAndLimitsBreadcrumbIdentifier = {
    route: 'settings.dunning-settings.fees-and-limits.edit',
    parameterLabel: 'marketRegion',
    parameters: ['marketRegion']
}

export default ($page) => {
    return [
        {
            route: 'settings.tenant-settings.create',
            label: 'messages.sitemap.settings.tenant_settings.tenant_settings',
            showInSidebar: true,
            permissions: ['setting.general'],
            id: 'settings-tenant-settings-create'
        },
        {
            route: 'settings.company-information.create',
            label: 'messages.sitemap.settings.company_information.company_information',
            showInSidebar: true,
            permissions: ['setting.general'],
            id: 'settings-company-information-create'
        },
        {
            route: 'settings.tenant-translations.index',
            label: 'messages.sitemap.settings.translations.tenant_translations',
            showInSidebar: true,
            permissions: [
                'setting.translations.view',
                'setting.translations.edit'
            ],
            id: 'settings-translations-index',
            children: [
                {
                    route: 'settings.tenant-translations.edit',
                    label: 'messages.sitemap.settings.translations.tenant_translations_edit',
                    showInSidebar: false,
                    id: 'settings-translations-edit'
                }
            ]
        },
        {
            route: 'settings.brands.index',
            label: 'messages.sitemap.settings.brands.brands',
            showInSidebar: true,
            permissions: ['setting.brands'],
            id: 'settings-brands-index',
            children: [
                {
                    route: 'settings.brands.create',
                    label: 'messages.sitemap.settings.brands.create'
                },
                {
                    route: 'settings.brands.edit',
                    label: 'messages.sitemap.settings.brands.edit',
                    identifier: brandBreadcrumbIdentifier
                },
                {
                    route: 'settings.brands.translations',
                    label: 'messages.sitemap.settings.brands.translation',
                    showInSidebar: false
                }
            ]
        },
        {
            route: 'settings.customer-segments.index',
            label: 'messages.sitemap.settings.customer-segments.customer-segments',
            showInSidebar: true,
            permissions: ['setting.customer_segments'],
            id: 'settings-customer-segments-index',
            children: [
                {
                    route: 'settings.customer-segments.create',
                    label: 'messages.sitemap.settings.customer-segments.create'
                },
                {
                    route: 'settings.customer-segments.edit',
                    label: 'messages.sitemap.settings.customer-segments.edit',
                    identifier: customerSegmentsBreadcrumbIdentifier
                }
            ]
        },
        {
            route: '',
            label: 'messages.sitemap.settings.apis',
            showInSidebar: true,
            showSecondDropdown: true,
            sidebarItemName: 'apis',
            id: 'settings-apis',
            permissions: [
                'setting.affiliate',
                'setting.cloudpit',
                'setting.jira',
                'setting.osa',
                'setting.whmcs',
                'setting.dwh',
                'setting.domain_tool',
                'setting.vm_monitoring',
                'setting.providerbox',
                'setting.zendesk',
                'setting.visma',
                'settings.herold_location',
                'setting.vanguard',
                'settings.messenger',
                'settings.netledger',
                'settings.mikkonaattori'
            ],
            children: [
                {
                    route: 'settings.affiliate-settings.create',
                    label: 'messages.sitemap.settings.affiliate_settings.affiliate_settings',
                    showInSidebar: true,
                    permissions: ['setting.affiliate'],
                    id: 'settings-apis-affiliate'
                },
                {
                    route: 'settings.cloudpit-settings.create',
                    label: 'messages.sitemap.settings.cloudpit_settings.cloudpit_settings',
                    showInSidebar: true,
                    permissions: ['setting.cloudpit'],
                    id: 'settings-apis-cloudpit-settings-create'
                },
                {
                    route: 'settings.domain-tool-settings.create',
                    label: 'messages.sitemap.settings.domain_tool_settings.domain_tool_settings',
                    showInSidebar: true,
                    permissions: ['setting.domain_tool'],
                    id: 'settings-apis-domain_tool-settings-create'
                },
                {
                    route: 'settings.dwh-settings.create',
                    label: 'messages.sitemap.settings.dwh_settings.dwh_settings',
                    showInSidebar: true,
                    permissions: ['setting.dwh'],
                    id: 'settings-apis-dwh-settings-create'
                },
                {
                    route: 'settings.vm-monitoring-settings.create',
                    label: 'messages.sitemap.settings.vm_monitoring',
                    showInSidebar: true,
                    permissions: ['setting.vm_monitoring'],
                    id: 'settings-apis-vm-monitoring-settings-create'
                },
                {
                    route: 'settings.jira-settings.create',
                    label: 'messages.sitemap.settings.jira_settings.jira_settings',
                    showInSidebar: true,
                    permissions: ['setting.jira'],
                    id: 'settings-apis-jira-settings-create'
                },
                {
                    route: 'settings.providerbox-settings.create',
                    label: 'messages.sitemap.settings.providerbox_settings.providerbox_settings',
                    showInSidebar: true,
                    permissions: ['setting.providerbox'],
                    id: 'settings-apis-providerbox-settings-create'
                },
                {
                    route: 'settings.whmcs-settings.create',
                    label: 'messages.sitemap.settings.whmcs_settings.whmcs_settings',
                    showInSidebar: true,
                    permissions: ['setting.whmcs'],
                    id: 'settings-apis-whmcs-settings-create'
                },
                {
                    route: 'settings.zen-desk-settings.create',
                    label: 'messages.sitemap.settings.zendesk_settings.zendesk_settings',
                    showInSidebar: true,
                    permissions: ['setting.zendesk'],
                    id: 'settings-apis-zendesk-settings-create'
                },
                {
                    route: 'settings.visma-settings.create',
                    label: 'messages.sitemap.settings.visma_settings.visma_settings',
                    showInSidebar: true,
                    permissions: ['setting.visma'],
                    id: 'settings-apis-visma-settings-create'
                },
                {
                    route: 'settings.herold-location-settings.create',
                    label: 'messages.sitemap.settings.herold-location-settings.herold-location-settings',
                    showInSidebar: true,
                    permissions: ['settings.herold_location'],
                    id: 'settings-apis-herold-location-settings-create'
                },
                {
                    route: 'settings.vanguard.create',
                    label: 'messages.sitemap.settings.vanguard-setting.vanguard-setting',
                    showInSidebar: true,
                    permissions: ['setting.vanguard'],
                    id: 'settings-apis-vanguard-setting-create'
                },
                {
                    route: 'settings.email-verification-settings.create',
                    label: 'messages.sitemap.settings.email_verification_settings.email_verification_settings',
                    showInSidebar: true,
                    permissions: ['setting.email_verification'],
                    id: 'settings-apis-email-verification-settings-create'
                },
                {
                    route: 'settings.hostlens-mail.create',
                    label: 'messages.sitemap.settings.hostlens-mail-setting.hostlens-mail-setting',
                    showInSidebar: true,
                    permissions: ['setting.hostlens_mail'],
                    id: 'settings-apis-hostlens-mail-setting-create'
                },
                {
                    route: 'settings.messenger-settings.create',
                    label: 'messages.sitemap.settings.messenger_settings.index',
                    showInSidebar: true,
                    permissions: ['settings.messenger'],
                    id: 'settings-apis-messenger-settings-create'
                },
                {
                    route: 'settings.netledger-settings.create',
                    label: 'messages.sitemap.settings.netledger_settings.index',
                    showInSidebar: true,
                    permissions: ['settings.netledger'],
                    id: 'settings-apis-netledger-settings-create'
                },
                ...($page.props.modules.php_eol_addon
                    ? [
                        {
                            route: 'settings.mikkonaattori-settings.create',
                            label: 'messages.sitemap.settings.mikkonaattori-setting.mikkonaattori-setting',
                            showInSidebar: true,
                            permissions: ['settings.mikkonaattori'],
                            id: 'settings-apis-mikkonaattori-settings-create'
                        }
                    ]
                    : []
                ),
            ]
        },
        {
            route: '',
            label: 'messages.sitemap.settings.communications',
            showInSidebar: true,
            showSecondDropdown: true,
            sidebarItemName: 'communications',
            id: 'settings-communications',
            permissions: [
                'setting.postal_delivery',
                'setting.communication_provider',
                'setting.sms_clients'
            ],
            children: [
                {
                    route: 'settings.postal-delivery-settings.create',
                    label: 'messages.sitemap.settings.postal_delivery.postal_delivery',
                    showInSidebar: true,
                    permissions: ['setting.postal_delivery'],
                    id: 'settings-communications-postal-delivery-create'
                },
                {
                    route: 'settings.communication-provider.create',
                    label: 'messages.sitemap.settings.communication_provider.communication_provider',
                    showInSidebar: true,
                    permissions: ['setting.communication_provider'],
                    id: 'settings-communications-communication-provider-create'
                },
                {
                    route: 'settings.communication-subscription-types.index',
                    label: 'messages.sitemap.settings.communication_subscription_types.index',
                    showInSidebar: true,
                    permissions: ['setting.communication_provider'],
                    id: 'settings-communication-subscription-types-index',
                    children: [
                        {
                            route: 'settings.communication-subscription-types.translations',
                            label: 'messages.sitemap.settings.communication_subscription_types.translations'
                        }
                    ]
                },
                ...($page.props.tenantSettings.sms_communications
                    ? [
                        {
                            route: 'settings.sms-clients-settings.create',
                            label: 'messages.sitemap.settings.sms-clients-settings.sms-clients-settings',
                            showInSidebar: true,
                            permissions: ['setting.sms_clients'],
                            id: 'settings-communications-api-clients-settings-create'
                        }
                    ]
                    : []
                )
            ]
        },
        {
            route: '',
            label: 'messages.sitemap.settings.legal.legal',
            showInSidebar: true,
            showSecondDropdown: true,
            sidebarItemName: 'legal',
            id: 'settings-legal',
            permissions: ['setting.terms', 'order.blocked_limits', 'setting.transfer'],
            children: [
                {
                    route: 'settings.terms-and-conditions.index',
                    label: 'messages.sitemap.settings.terms_and_conditions.terms_and_conditions',
                    showInSidebar: true,
                    permissions: ['setting.terms'],
                    id: 'settings-legal-terms-and-conditions-index',
                    children: [
                        {
                            route: 'settings.terms-and-conditions.create',
                            label: 'messages.sitemap.settings.terms_and_conditions.create',
                            id: 'settings-legal-terms-and-conditions-create'
                        }
                    ]
                },
                {
                    route: 'settings.transfer-settings.create',
                    label: 'messages.sitemap.settings.legal.transfers',
                    showInSidebar: true,
                    permissions: ['setting.transfer'],
                    id: 'settings-legal-transfer-settings-index'
                }
            ]
        },
        {
            route: '',
            label: 'messages.sitemap.settings.billing_accounting',
            showInSidebar: true,
            id: 'settings-billing-and-accounting',
            showSecondDropdown: true,
            sidebarItemName: 'billing',
            permissions: [
                'setting.tax_rules',
                'setting.tax_exemptions',
                'setting.revenue_cost_centers',
                'setting.finance_system',
                'setting.reminder',
                'setting.invoice_pdf',
                'setting.dunning_pdf',
                'setting.bank_accounts',
                'setting.credit_note_types',
                'setting.tax_rules_credit_note',
                'setting.osa',
                'setting.adyen',
                'setting.windata',
                'billing_and_accounting.price_adjustments'
            ],
            children: [
                {
                    route: 'settings.adyen-settings.create',
                    label: 'messages.sitemap.settings.adyen_settings.adyen_settings',
                    showInSidebar: true,
                    permissions: ['setting.adyen'],
                    id: 'settings-billing-and-accounting-adyen-settings-index'
                },
                {
                    route: 'settings.accounting-products.index',
                    label: 'messages.sitemap.settings.accounting_products.accounting_products',
                    showInSidebar: true,
                    permissions: ['setting.revenue_cost_centers'],
                    id: 'settings-billing-and-accounting-accounting-products-index',
                    children: [
                        {
                            route: 'settings.accounting-products.create',
                            label: 'messages.sitemap.settings.accounting_products.create'
                        },
                        {
                            route: 'settings.accounting-products.edit',
                            label: 'messages.sitemap.settings.accounting_products.edit',
                            identifier: accountingProductsBreadcrumbIdentifier
                        }
                    ]
                },
                ...($page.props.tenantSettings.automatic_price_adjustment
                    ? [
                        {
                            route: 'settings.price-adjustments.index',
                            label: 'messages.sitemap.billing_and_accounting.price_adjustments',
                            showInSidebar: true,
                            permissions: ['billing_and_accounting.price_adjustments'],
                            id: 'billing-and-accounting-price_adjustment-index'
                        }
                    ]
                    : []
                ),
                {
                    route: 'settings.bank-accounts.index',
                    label: 'messages.sitemap.settings.bank_accounts.bank_accounts',
                    showInSidebar: true,
                    permissions: ['setting.bank_accounts'],
                    id: 'settings-billing-and-accounting-bank-accounts-index',
                    children: [
                        {
                            route: 'settings.bank-accounts.create',
                            label: 'messages.sitemap.settings.bank_accounts.create'
                        },
                        {
                            route: 'settings.bank-accounts.edit',
                            label: 'messages.sitemap.settings.bank_accounts.edit',
                            identifier: bankAccountBreadcrumbIdentifier
                        }
                    ]
                },
                {
                    route: 'settings.credit-note-types.index',
                    label: 'messages.sitemap.settings.credit_note_types.credit_note_types',
                    showInSidebar: true,
                    permissions: ['setting.credit_note_types'],
                    id: 'settings-billing-and-accounting-credit-note-types-index',
                    children: [
                        {
                            route: 'settings.credit-note-types.create',
                            label: 'messages.sitemap.settings.credit_note_types.create'
                        },
                        {
                            route: 'settings.credit-note-types.translations',
                            label: 'messages.sitemap.settings.credit_note_types.translation',
                            showInSidebar: false
                        },
                        {
                            route: 'settings.credit-note-types.edit',
                            label: 'messages.sitemap.settings.credit_note_types.edit',
                            identifier: creditNoteTypeBreadcrumbIdentifier
                        }
                    ]
                },
                {
                    route: 'settings.currency-rates-api-settings.create',
                    label: 'messages.sitemap.settings.currency-rates-api-settings.currency-rates-api-settings',
                    showInSidebar: true,
                    permissions: ['setting.currency_rates_api_settings'],
                    id: 'settings-billing-and-accounting-currency-rates-api-settings-index'
                },
                {
                    route: 'settings.dunning-settings.create',
                    label: 'messages.sitemap.settings.dunning_settings.dunning_settings',
                    showInSidebar: true,
                    permissions: ['setting.reminder'],
                    id: 'settings-billing-and-accounting-dunning-settings-create',
                    children: [
                        {
                            route: 'settings.manage-sepa-retry.create',
                            label: 'messages.sitemap.settings.sepa_retry.create',
                            showInSidebar: false
                        },
                        {
                            route: 'settings.sepa-retry-failure-codes.index',
                            label: 'messages.sitemap.settings.sepa_retry.failure_codes',
                            showInSidebar: false
                        },
                        {
                            route: 'settings.dunning-settings.fees-and-limits.index',
                            label: 'settings.dunning_fees_and_limits.title',
                            showInSidebar: false
                        },
                        {
                            route: 'settings.dunning-settings.fees-and-limits.edit',
                            label: 'settings.dunning_fees_and_limits.edit.title',
                            showInSidebar: false,
                            identifier: dunningFeesAndLimitsBreadcrumbIdentifier
                        },
                    ]
                },
                {
                    route: 'settings.dunning-pdf-settings.index',
                    label: 'messages.sitemap.settings.dunning_pdf_settings.dunning_pdf_settings',
                    showInSidebar: true,
                    permissions: ['setting.dunning_pdf'],
                    id: 'settings-billing-and-accounting-dunning-pdf-settings-index',
                    children: [
                        {
                            route: 'settings.dunning-pdf-settings.create',
                            label: 'messages.sitemap.settings.dunning_pdf_settings.create'
                        },
                        {
                            route: 'settings.dunning-pdf-settings.edit',
                            label: 'messages.sitemap.settings.dunning_pdf_settings.edit'
                        }
                    ]
                },
                {
                    route: 'settings.finance-system-settings.create',
                    label: 'messages.sitemap.settings.finance_system_settings.finance_system_settings',
                    showInSidebar: true,
                    permissions: ['setting.finance_system'],
                    id: 'settings-billing-and-accounting-finance-system-settings-create'
                },
                {
                    route: 'settings.invoice-delivery-types.index',
                    label: 'messages.sitemap.settings.invoice_delivery_types.index',
                    showInSidebar: true,
                    permissions: ['setting.invoice_delivery'],
                    id: 'settings-invoice-delivery-types-index',
                    children: [
                        {
                            route: 'settings.invoice-delivery-types.edit',
                            label: 'messages.sitemap.settings.invoice_delivery_types.edit',
                            identifier: invoiceDeliveryTypeIdentifier,
                            id: 'settings-invoice-delivery-types-edit'
                        }
                    ]
                },
                {
                    route: 'settings.invoice-pdf-settings.index',
                    label: 'messages.sitemap.settings.invoice_pdf_settings.invoice_pdf_settings',
                    showInSidebar: true,
                    permissions: ['setting.invoice_pdf'],
                    id: 'settings-billing-and-accounting-invoice-pdf-settings-index',
                    children: [
                        {
                            route: 'settings.invoice-pdf-settings.create',
                            label: 'messages.sitemap.settings.invoice_pdf_settings.create'
                        },
                        {
                            route: 'settings.invoice-pdf-settings.edit',
                            label: 'messages.sitemap.settings.invoice_pdf_settings.edit'
                        }
                    ]
                },
                ...($page.props.tenantSettings.online_service_fee
                    ? [
                        {
                            route: 'tools.service-fees.index',
                            label: 'messages.sitemap.billing_and_accounting.service_fee.index',
                            showInSidebar: true,
                            id: 'billing-and-accounting-online-service-fee-index',
                            children: [
                                {
                                    route: 'tools.service-fees.create',
                                    label: 'messages.sitemap.billing_and_accounting.service_fee.create'
                                },
                                {
                                    route: 'tools.service-fees.edit',
                                    label: 'messages.sitemap.billing_and_accounting.service_fee.edit'
                                }
                            ]
                        }
                    ]
                    : []
                ),
                {
                    route: 'settings.tax-rules.index',
                    label: 'messages.sitemap.settings.tax_rules.tax_rules',
                    showInSidebar: true,
                    permissions: ['setting.tax_rules'],
                    id: 'settings-billing-and-accounting-tax-rules-index',
                    children: [
                        {
                            route: 'settings.tax-rules.create',
                            label: 'messages.sitemap.settings.tax_rules.create'
                        },
                        {
                            route: 'settings.tax-rules.edit',
                            label: 'messages.sitemap.settings.tax_rules.edit',
                            identifier: taxRuleBreadcrumbIdentifier
                        },
                        {
                            route: 'settings.tax-rules.translations',
                            label: 'messages.sitemap.settings.tax_rules.translation',
                            showInSidebar: false
                        }
                    ]
                },
                {
                    route: 'settings.tax-exemption.index',
                    label: 'messages.sitemap.settings.tax_exemption.tax_exemption',
                    showInSidebar: true,
                    permissions: ['setting.tax_exemptions'],
                    id: 'settings-billing-and-accounting-tax-exemption-index',
                    children: [
                        {
                            route: 'settings.tax-exemption.create',
                            label: 'messages.sitemap.settings.tax_exemption.create'
                        },
                        {
                            route: 'settings.tax-exemption.edit',
                            label: 'messages.sitemap.settings.tax_exemption.edit',
                            identifier: taxExemptionBreadcrumbIdentifier
                        },
                        {
                            route: 'settings.tax-exemption.translations',
                            label: 'messages.sitemap.settings.tax_exemption.translation',
                            showInSidebar: false
                        }
                    ]
                },
                {
                    route: 'settings.tax-rules-credit-notes.index',
                    label: 'messages.sitemap.settings.tax_rules_credit_notes.tax_rules_credit_notes',
                    showInSidebar: true,
                    permissions: ['setting.tax_rules_credit_note'],
                    id: 'settings-billing-and-accounting-tax-rules-credit-notes-index',
                    children: [
                        {
                            route: 'settings.tax-rules-credit-notes.create',
                            label: 'messages.sitemap.settings.tax_rules_credit_notes.create'
                        },
                        {
                            route: 'settings.tax-rules-credit-notes.edit',
                            label: 'messages.sitemap.settings.tax_rules_credit_notes.edit',
                            identifier: taxRulesCreditNotesBreadcrumbIdentifier
                        },
                        {
                            route: 'settings.tax-rules-credit-notes.translations',
                            label: 'messages.sitemap.settings.tax_rules_credit_notes.translation',
                            showInSidebar: false
                        }
                    ]
                },
                {
                    route: 'settings.sepa-settings.create',
                    label: 'messages.sitemap.settings.sepa_settings.sidebar_text',
                    showInSidebar: true,
                    permissions: ['setting.general'],
                    id: 'settings-billing-and-accounting-sepa-settings-index'
                }
            ]
        },
        {
            route: '',
            label: 'messages.sitemap.tools.fulfillment.fulfillment',
            showInSidebar: true,
            showSecondDropdown: true,
            sidebarItemName: 'fulfillment',
            id: 'settings-fulfillment-index',
            permissions: [
                'fulfillment.view',
                'dns_templates.view'
            ],
            children: [
                {
                    route: 'settings.hosting-notification-settings.create',
                    label: 'messages.sitemap.settings.hosting_notification_settings.hosting',
                    showInSidebar: true,
                    permissions: ['setting.hosting'],
                    id: 'settings-fulfillment-hosting-notification-settings-create'
                },
                {
                    route: 'products.accounts.index',
                    label: 'messages.sitemap.products.fulfillment.fulfillmentAccounts',
                    showInSidebar: true,
                    permissions: ['fulfillment.view'],
                    id: 'settings-fulfillment-accounts-index',
                    children: [
                        {
                            route: 'products.accounts.create',
                            label: 'messages.sitemap.products.fulfillment.create'
                        },
                        {
                            route: 'products.accounts.edit',
                            label: 'messages.sitemap.products.fulfillment.update',
                            identifier: accountBreadcrumbIdentifier
                        },
                        {
                            route: 'products.accounts.show',
                            label: 'messages.sitemap.products.fulfillment.show',
                            identifier: accountBreadcrumbIdentifier
                        }
                    ]
                },
                {
                    route: 'products.fulfillment-modules.index',
                    label: 'messages.sitemap.products.modules.index',
                    showInSidebar: true,
                    permissions: ['fulfillment.create'],
                    id: 'settings-fulfillment-modules'
                },
                {
                    route: 'products.accounts.index',
                    label: 'messages.sitemap.products.fulfillmentGroup.fulfillmentGroup',
                    permissions: ['fulfillment.view'],
                    children: [
                        {
                            route: 'products.account-groups.create',
                            label: 'messages.sitemap.products.fulfillmentGroup.create'
                        },
                        {
                            route: 'products.account-groups.edit',
                            label: 'messages.sitemap.products.fulfillmentGroup.update',
                            identifier: accountGroupBreadcrumbIdentifier
                        }
                    ]
                },
                {
                    route: 'settings.dns-providers.index',
                    label: 'messages.sitemap.settings.dns_provider.dns_providers',
                    showInSidebar: true,
                    showSecondDropdown: true,
                    sidebarItemName: 'dns-providers',
                    id: 'dns-providers-index',
                    children: [
                        {
                            route: 'settings.dns-providers.show',
                            label: 'messages.sitemap.settings.dns_provider.dns_provider_show'
                        },
                        {
                            route: 'settings.dns-providers.create',
                            label: 'messages.sitemap.settings.dns_provider.dns_provider_create'
                        },
                        {
                            route: 'settings.dns-providers.edit',
                            label: 'messages.sitemap.settings.dns_provider.dns_provider_edit'
                        }
                    ],
                    permissions: [
                        'settings.dns'
                    ]
                },
                {
                    route: 'products.dns-templates.index',
                    label: 'messages.sitemap.settings.dns_templates.dns_templates',
                    showInSidebar: true,
                    permissions: ['dns_templates.view'],
                    id: 'settings-fulfillment-dns-templates-index',
                    children: [
                        {
                            route: 'products.dns-templates.create',
                            label: 'messages.sitemap.settings.dns_templates.create_dns_templates'
                        },
                        {
                            route: 'products.dns-templates.edit',
                            label: 'messages.sitemap.settings.dns_templates.edit_dns_templates',
                            identifier: dnsTemplateBreadcrumbIdentifier
                        },
                        {
                            route: 'products.dns-templates.show',
                            label: 'messages.sitemap.settings.dns_templates.show_dns_templates',
                            identifier: dnsTemplateBreadcrumbIdentifier
                        }
                    ]
                },
                ...($page.props.modules.ms365
                    ? [
                        {
                            route: 'settings.microsoft365-settings.index',
                            label: 'messages.sitemap.settings.microsoft365_settings.tokens',
                            showInSidebar: true,
                            permissions: ['setting.ms365'],
                            id: 'settings-fulfillment-microsoft365-settings-index'
                        }
                    ]
                    : []
                ),
                {
                    route: 'settings.domain-configuration.index',
                    label: 'messages.sitemap.settings.domain_configuration.domain_configuration',
                    showInSidebar: true,
                    permissions: ['setting.fulfillment.domain_config'],
                    id: 'settings-domain-configuration-index',
                    children: [
                        {
                            route: 'settings.domain-configuration.create',
                            label: 'messages.sitemap.settings.domain_configuration.create'
                        },
                        {
                            route: 'settings.domain-configuration.edit',
                            label: 'messages.sitemap.settings.domain_configuration.edit',
                            identifier: domainConfigurationIdentifier
                        }
                    ]
                },
                {
                    route: 'settings.idn-character-sets.index',
                    label: 'messages.sitemap.settings.idn_character_sets.idn_character_sets',
                    showInSidebar: true,
                    permissions: ['setting.fulfillment.idn_character_sets'],
                    id: 'settings-idn-character-sets-index',
                    children: [
                        {
                            route: 'settings.idn-character-sets.create',
                            label: 'messages.sitemap.settings.idn_character_sets.create'
                        },
                        {
                            route: 'settings.idn-character-sets.edit',
                            label: 'messages.sitemap.settings.idn_character_sets.edit',
                            identifier: idnCharacterSetIdentifier
                        }
                    ]
                },
                ...($page.props.modules.antagonist_da
                    ? [
                        {
                            route: 'settings.my-antagonist-settings.create',
                            label: 'messages.sitemap.settings.my_antagonist.my_antagonist',
                            showInSidebar: true,
                            showSecondDropdown: true,
                            sidebarItemName: 'my-antagonist',
                            id: 'my-antagonist-index',
                            permissions: [
                                'settings.my_antagonist'
                            ]
                        }
                    ]
                    : []
                ),
                ...($page.props.modules.php_eol_addon
                    ? [
                        {
                            route: 'settings.s3-settings.create',
                            label: 'messages.sitemap.settings.s3_settings.s3_settings',
                            showInSidebar: true,
                            showSecondDropdown: true,
                            sidebarItemName: 's3-settings',
                            id: 's3-settings-index',
                            permissions: [
                                'setting.s3_setting'
                            ]
                        }
                    ]
                    : []
                ),
                {
                    route: 'settings.contract-reminders-settings.create',
                    label: 'messages.sitemap.settings.contract_reminders_settings.input-reminder',
                    showInSidebar: true,
                    permissions: ['setting.contract_reminders_settings'],
                    id: 'settings-fulfillment-contract-reminders-settings-create'
                },
            ]
        },
        {
            route: '',
            label: 'messages.sitemap.settings.permissions.permissions',
            showInSidebar: true,
            showSecondDropdown: true,
            sidebarItemName: 'permissions',
            id: 'settings-permissions',
            permissions: [
                'setting.permissions',
                'setting.permissions.edit',
                'setting.permission_set_limits'
            ],
            children: [
                {
                    route: 'settings.permissions.index',
                    label: 'messages.sitemap.settings.permissions.permissions',
                    showInSidebar: true,
                    permissions: ['setting.permissions'],
                    id: 'settings-permissions-index',
                    children: [
                        {
                            route: 'settings.permissions.edit',
                            label: 'messages.sitemap.settings.permissions.permission_edit',
                            permissions: ['setting.permissions.edit'],
                            identifier: permissionIdentifier,
                            id: 'settings-permissions-edit'
                        }
                    ]
                },
                {
                    route: 'settings.permissions-set-limits.create',
                    label: 'messages.sitemap.settings.permissions.set_limits',
                    showInSidebar: true,
                    permissions: ['setting.permission_set_limits'],
                    id: 'settings-permission-set-limits'
                }
            ]
        },
        {
            route: '',
            label: 'messages.sitemap.orders.orders',
            showInSidebar: true,
            showSecondDropdown: true,
            sidebarItemName: 'orders',
            id: 'settings-orders',
            permissions: ['setting.orders'],
            children: [
                {
                    route: 'settings.order-settings.create',
                    label: 'messages.sitemap.settings.orders.order_client',
                    showInSidebar: true,
                    permissions: ['setting.osa', 'setting.orders'],
                    id: 'settings-apis-order-settings-create'
                },
                {
                    route: 'settings.order-block-limit-settings.index',
                    label: 'messages.sitemap.settings.orders.order_block_limits',
                    showInSidebar: true,
                    permissions: ['order.blocked_limits'],
                    id: 'settings-orders-order-block-limit-settings-index'
                },
                ...($page.props.isPsaOrderSupported
                    ? [
                        {
                            route: 'settings.order-manual-check-group-settings.index',
                            label: 'messages.sitemap.settings.orders.manual_checks',
                            showInSidebar: true,
                            permissions: ['setting.orders'],
                            id: 'settings-manual-checks-groups-index',
                            children: [
                                {
                                    route: 'settings.order-manual-check-group-settings.edit',
                                    label: 'messages.sitemap.settings.orders.manual_checks_edit_group',
                                    identifier: orderManualCheckGroupIdentifier,
                                    id: 'settings-manual-checks-groups-edit'
                                },
                                {
                                    route: 'settings.order-manual-check-settings.create',
                                    label: 'messages.sitemap.settings.orders.manual_checks_create',
                                    id: 'order-manual-check-settings-store'
                                },
                                {
                                    route: 'settings.order-manual-check-settings.edit',
                                    label: 'messages.sitemap.settings.orders.manual_checks_edit',
                                    identifier: orderManualCheckIdentifier,
                                    id: 'order-manual-check-settings-update'
                                }
                            ]
                        }
                    ]
                    : []
                )
            ]
        },
        {
            route: 'settings.dashboard-settings.create',
            label: 'messages.sitemap.settings.dashboard_settings.dashboard_settings',
            showInSidebar: false,
            permissions: [],
            id: 'dashboard-settings-create'
        },
        {
            route: 'settings.list-of-values',
            label: 'messages.sitemap.settings.list_of_values',
            showInSidebar: true,
            permissions: [
                'settings.lov_payment_terms',
                'settings.lov_legal_forms',
                'settings.lov_countries',
                'settings.lov_incidents',
                'settings.lov_termination_reasons',
                'settings.lov_billing_cycles',
                'settings.original_brands',
                'settings.electronic_invoice_operators',
            ],
            id: 'settings-list-of-values',
            children: [
                {
                    route: 'settings.payment-terms.edit',
                    label: 'messages.sitemap.settings.payment_terms.edit',
                    identifier: paymentTermBreadcrumbIdentifier,
                    id: 'settings-payment-terms-edit'
                },
                {
                    route: 'settings.payment-terms.index',
                    label: 'messages.sitemap.settings.payment_terms.index',
                    id: 'settings-payment-terms-index',
                    activeSidebarRoute: 'settings.payment-terms.index'
                },
                {
                    route: 'settings.payment-terms.create',
                    label: 'messages.sitemap.settings.payment_terms.create',
                    id: 'settings-payment-terms-create'
                },
                {
                    route: 'settings.countries.create',
                    label: 'messages.sitemap.settings.countries.create'
                },
                {
                    route: 'settings.countries.index',
                    label: 'messages.sitemap.settings.countries.countries',
                    activeSidebarRoute: 'settings.payment-terms.index',
                    children: [
                        {
                            route: 'settings.countries.show',
                            label: 'messages.sitemap.settings.countries.show',
                            identifier: {
                                route: 'settings.countries.show',
                                parameterLabel: 'country',
                                parameters: ['country']
                            },
                        },
                        {
                            route: 'settings.countries.edit',
                            label: 'messages.sitemap.settings.countries.edit',
                            identifier: {
                                route: 'settings.countries.show',
                                parameterLabel: 'country',
                                parameters: ['country']
                            },
                        },
                        {
                            route: 'settings.countries.states.index',
                            label: 'messages.sitemap.settings.countries.states.index',
                            identifier: {
                                route: 'settings.countries.show',
                                parameterLabel: 'country',
                                parameters: ['country']
                            },
                            children: [
                                {
                                    route: 'settings.countries.states.edit',
                                    label: 'messages.sitemap.settings.countries.states.edit',
                                    parameters: ['country'],
                                },
                                {
                                    route: 'settings.countries.states.create',
                                    label: 'messages.sitemap.settings.countries.states.create',
                                },
                            ]
                        },
                    ]
                },
                {
                    route: 'settings.legal-forms.index',
                    label: 'messages.sitemap.settings.legal_forms.index',
                    activeSidebarRoute: 'settings.payment-terms.index'
                },
                {
                    route: 'settings.incident-values.index',
                    label: 'messages.sitemap.settings.lov_incidents.index',
                    activeSidebarRoute: 'settings.payment-terms.index'
                },
                {
                    route: 'settings.incident-values.create',
                    label: 'messages.sitemap.settings.lov_incidents.create',
                    activeSidebarRoute: 'settings.payment-terms.index'
                },
                {
                    route: 'settings.incident-values.edit',
                    label: 'messages.sitemap.settings.lov_incidents.edit',
                    activeSidebarRoute: 'settings.payment-terms.index'
                },
                {
                    route: 'settings.termination-reasons.index',
                    label: 'messages.sitemap.settings.termination_reasons.index',
                    activeSidebarRoute: 'settings.payment-terms.index'
                },
                {
                    route: 'settings.termination-reasons.create',
                    label: 'messages.sitemap.settings.termination_reasons.create',
                    activeSidebarRoute: 'settings.payment-terms.index'
                },
                {
                    route: 'settings.termination-reasons.edit',
                    label: 'messages.sitemap.settings.termination_reasons.edit',
                    activeSidebarRoute: 'settings.payment-terms.index'
                },
                {
                    route: 'settings.billing-cycles.index',
                    label: 'messages.sitemap.settings.billing_cycles.index',
                    activeSidebarRoute: 'settings.billing-cycles.index'
                },
                {
                    route: 'settings.original-brands.index',
                    label: 'messages.sitemap.settings.original_brands.index',
                    activeSidebarRoute: 'settings.original-brands.index'
                },
                {
                    route: 'settings.original-brands.create',
                    label: 'messages.sitemap.settings.original_brands.create',
                    activeSidebarRoute: 'settings.original_brands.index'
                },
                {
                    route: 'settings.original-brands.edit',
                    label: 'messages.sitemap.settings.original_brands.edit',
                    activeSidebarRoute: 'settings.original_brands.index'
                },
                {
                    route: 'settings.electronic-invoice-operators.index',
                    label: 'messages.sitemap.settings.electronic_invoice_operators.index',
                    activeSidebarRoute: 'settings.electronic-invoice-operators.index'
                },
            ]
        },
        {
            route: 'settings.market-regions.index',
            label: 'messages.sitemap.settings.market_regions.market_regions',
            showInSidebar: true,
            permissions: ['market_region.view'],
            id: 'settings-market-regions-index',
            children: [
                {
                    route: 'settings.market-regions.create',
                    label: 'messages.sitemap.settings.market_regions.create',
                    permissions: ['market_region.create']
                },
                {
                    route: 'settings.market-regions.edit',
                    label: 'messages.sitemap.settings.market_regions.edit',
                    permissions: ['market_region.edit'],
                    identifier: marketRegionBreadcrumbIdentifier
                },
            ]
        }
    ]
}
